<section class="keywords-section">
  <div
    [ngClass]="[currentUrl === '/' ||  currentUrl === '/pages/contact-us' ||  currentUrl !== '/pages/download-tender-mobile-app' ? 'container-xl' : 'container-fluid px-50']">

    <div *ngIf="trendingSearchList?.length" class="d-flex align-items-center mb-15">
      <h4 class="mr-20">Trending Searches</h4>
    </div>
    <ul class="mb-30">
      <li *ngFor="let filter of trendingSearchList; let i = index">
        <a [href]="baseUrl + '/' +  filter.searchUrl"
          (click)="navigate($event, filter.searchUrl)">{{filter?.searchTerm}} ({{filter?.searchVolume | indianNumber}}
          Searches)
          <div class="d-inline-block d-lg-none saperator-mobile"></div>
        </a>
      </li>
    </ul>


    <div class="d-flex align-items-center mb-15">
      <h4 class="mr-20">Tender By States</h4>
      <a class="view-more-btn" [href]="baseUrl + '/all-tenders/states'">View More<i
          class="arrow-right-red sprite-img"></i></a>
    </div>
    <ul class="mb-30">
      <li *ngFor="let filter of statesList?.slice(0, 20); let i = index">
        <a [href]="baseUrl + '/' + filter.link + '-tenders/active'"
          (click)="navigate($event, filter.link + '-tenders/active')">{{filter?.name}} Tenders
          <div class="d-inline-block d-lg-none saperator-mobile"></div>
        </a>
      </li>
    </ul>

    <div class="d-flex align-items-center mb-15">
      <h4 class="mr-20">Tender By Authorities</h4>
      <a class="view-more-btn" [href]="baseUrl + '/all-tenders/authorities'">View More<i
          class="arrow-right-red sprite-img"></i></a>
    </div>
    <ul class="mb-30">
      <li *ngFor="let filter of authorityList?.slice(0, 20); let i = index">
        <a [href]="baseUrl + '/' + filter.link + '-tenders/active'"
          (click)="navigate($event, filter.link + '-tenders/active')">{{filter?.name}} Tenders
          <div class="d-inline-block d-lg-none saperator-mobile"></div>

        </a>
      </li>
    </ul>

    <div class="d-flex align-items-center mb-15">
      <h4 class="mr-20">Tender By Categories</h4>
      <a class="view-more-btn" [href]="baseUrl + '/all-tenders/categories'">View
        More<i class="arrow-right-red sprite-img"></i></a>
    </div>
    <ul class="mb-30">
      <li *ngFor="let filter of categoryList?.slice(0, 20); let i = index">
        <a [href]="baseUrl + '/' + filter.link + '-tenders/active'"
          (click)="navigate($event, filter.link + '-tenders/active')">{{filter?.name}} Tenders
          <div class="d-inline-block d-lg-none saperator-mobile"></div>
        </a>
      </li>
    </ul>

    <div class="d-flex align-items-center mb-15">
      <h4 class="mr-20">Tender By Procurement</h4>
      <a class="view-more-btn" [href]="baseUrl + '/all-tenders/procurement'">View More<i
          class="arrow-right-red sprite-img"></i></a>
    </div>
    <ul class="mb-30">
      <li *ngFor="let filter of procurementList?.slice(0, 20); let i = index">
        <a [href]="baseUrl + '/' + filter.link + '-tenders/active'"
          (click)="navigate($event, filter.link + '-tenders/active')">{{filter?.name}} Tenders
          <div class="d-inline-block d-lg-none saperator-mobile"></div>
        </a>
      </li>
    </ul>

  </div>
</section>